import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import $ from 'jquery';
import { withModelInfo } from '../common/ModelInfoContext';
import fetchWithCache from '../api/fetchWithCache';
import { getDefaultLinks } from '../resources/shoppingLinks/shoppingHelper.constant';
import {
  cmsScriptLoaded,
  fetchInitialConfig,
  shoppingLinksLoaded
} from '../store/actions';
import fetchFeatures from '../api/fetchFeatures';
import Error from '../views/error/Error';
import Main from './Main';
import normalizeShoppingLinks from './normalizeShoppingLinks';
import normalizeCmsLinks from './normalizeCmsLinks';

const mapStateToProps = state => {
  return {
    postalCode: state.params.postalCode,
    appResources: state.appResources
  };
};

class MainFetch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: null,
      features: null,
      isLoaded: false,
      isError: false,
      shoppingLinks: {}
    };
  }

  fetchShoppingLinks() {
    const { modelInfo, dispatch, appResources } = this.props;
    const { isQuantum, deviceType } = modelInfo;

    if (!isQuantum) {
      const url = window.cmsLinkUrl;

      if (!url) {
        return Promise.resolve(null);
      }

      const find = Array.prototype.find;
      return new Promise(resolve => {
        $.getScript(url).always(function() {
          Array.prototype.find = find;
          resolve({});
        });
      }).then(() => {
        setTimeout(() => {
          const result = normalizeCmsLinks(modelInfo);
          this.setState({
            shoppingLinks: result
          });
          dispatch(cmsScriptLoaded(window.GmdsCmsLinks));
        });
      });
    }

    const url = _.get(appResources, 'urls.shoppingLinksUrl');
    return fetchWithCache(url)
      .then(data => {
        const result = normalizeShoppingLinks(modelInfo)(data);
        this.setState({
          shoppingLinks: result
        });
        return data;
      })
      .catch(() => getDefaultLinks(appResources, deviceType))
      .then(data => {
        dispatch(shoppingLinksLoaded(data));
      });
  }

  fetchFeatures() {
    const { modelInfo, postalCode } = this.props;
    const {
      legacyServicesPath,
      modelPath,
      country,
      enableDimensions
    } = modelInfo;

    if (enableDimensions) {
      return fetchFeatures({
        legacyServicesPath,
        modelPath,
        country,
        postalCode
      }).catch(() => null);
    }

    return Promise.resolve(null);
  }

  fetchConfig() {
    const { dispatch, postalCode, modelInfo } = this.props;

    const searchParams = new URLSearchParams(window.location.search);
    const params = {
      ss: searchParams.get('ss'),
      styleId: searchParams.get('styleId'),
      rpo: searchParams.get('rpo'),
      country: modelInfo.country,
      postalCode
    };

    // wrapping in promise to ensure we don't continue until complete and resolve config for dependent states
    return new Promise((resolve, reject) => {
      dispatch(fetchInitialConfig(params, resolve, reject));
    });
  }

  componentDidMount() {
    Promise.all([
      this.fetchConfig(),
      this.fetchFeatures(),
      this.fetchShoppingLinks()
    ])
      .then(([config, features]) => {
        this.setState({
          config,
          features,
          isLoaded: true
        });
      })
      .catch(err => {
        this.setState({ isError: true, error: err });
      });
  }

  render() {
    if (this.state.isLoaded) {
      return (
        <Main
          trimFeatures={this.state.features}
          shoppingLinks={this.state.shoppingLinks}
        />
      );
    }
    if (this.state.isError) {
      return <Error error={this.state.error} />;
    }
    return null;
  }
}

export default withRouter(withModelInfo(connect(mapStateToProps)(MainFetch)));
